import { css } from 'linaria';
import { strictBreakpoints } from '../../../media';

export const costStyles = css`
	display: flex;
	flex-direction: column;
	gap: 24px;
	padding: 32px 40px;
	background: var(--background-secondary);
	border-radius: 8px;
	${strictBreakpoints.onlyTablet} {
		padding: 32px 54px;
		margin: 0 -54px;
		border-radius: 0;
	}
	${strictBreakpoints.onlyMobile} {
		padding: 32px 16px;
		margin: 0 -16px;
		border-radius: 0;
	}

	.cost-text {
		.title {
			margin-bottom: 16px;
			${strictBreakpoints.onlyMobile} {
				margin-bottom: 12px;
			}
		}
	}
`;
